// @flow

import React from 'react';
import EmailSubscriptionContainer from 'client/components/subscribe/email';
import HealthEntryPoint from 'client/components/ifpApp/healthEntryPoint';

type Props = {
  id: string,
};

export default function EmailOrHealthEntry(props: Props) {
  // Note: show email subscription option before CCA start
  return new Date() < new Date(2019, 9, 15) ? (
    <EmailSubscriptionContainer
      lists={['oep-plans-2019']}
      className="focus-white-color"
      id={props.id}
      subscribeSuccessStyle={{ fontSize: '14px', fontWeight: '600', marginBottom: '2rem' }}
      buttonClassName="primary oep-hover"
      buttonLabel={{ path: 'common.cta.getNotified' }}
      subscribedLabel={{ path: 'common.label.emailSubscribed' }} />
  ) : (
    <HealthEntryPoint id={props.id} />
  );
}
